import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-center mb-4" }
const _hoisted_2 = {
  filter: "gender",
  sort: "gender"
}
const _hoisted_3 = {
  filter: "model",
  sort: "model"
}
const _hoisted_4 = {
  filter: "size",
  sort: "size"
}
const _hoisted_5 = {
  filter: "mainFabricSQM",
  sort: "mainFabricSQM"
}
const _hoisted_6 = {
  filter: "gussetLiningSQM",
  sort: "gussetLiningSQM"
}
const _hoisted_7 = {
  filter: "legElasticCm",
  sort: "legElasticCm"
}
const _hoisted_8 = {
  filter: "waistElasticBandCm",
  sort: "waistElasticBandCm"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { colspan: "12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uploadExcelModal()))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Upload Excel",
          text: "Upload Excel"
        })
      ])
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      items: _ctx.configurations
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_2, [
              _createVNode(_component_localized_text, {
                localizedKey: "Gender",
                text: "Gender"
              })
            ]),
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_localized_text, {
                localizedKey: "Model",
                text: "Model"
              })
            ]),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Size",
                text: "Size"
              })
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Main fabric (m²)",
                text: "Main fabric (m²)"
              })
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "Gusset lining (m²)",
                text: "Gusset lining (m²)"
              })
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: "Leg elastic length cm",
                text: "Leg elastic length cm"
              })
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "Waist elastic length cm",
                text: "Waist elastic length cm"
              })
            ])
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.data.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                _createElementVNode("td", _hoisted_10, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "No Elements Found",
                    text: "No Elements Found"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.BottomUnderwearSquareMeterCombinationsConfig[]), (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(item.gender), 1),
              _createElementVNode("td", null, _toDisplayString(item.model), 1),
              _createElementVNode("td", null, _toDisplayString(item.size), 1),
              _createElementVNode("td", null, _toDisplayString(item.mainFabricSQM), 1),
              _createElementVNode("td", null, _toDisplayString(item.gussetLiningSQM), 1),
              _createElementVNode("td", null, _toDisplayString(item.legElasticCm), 1),
              _createElementVNode("td", null, _toDisplayString(item.waistElasticLenghtCm), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["items"])
  ], 64))
}